/* @flow */
import React from 'react';
import cx from 'classnames';
import NavItem from 'components/NavItem.jsx';

import './styles/SettingsNav.scss';

type Props = {
  className?: ?string,
  showMessageSettings: boolean,
  canGoToTransactionSettings: boolean,
  canOwnGroups: boolean,
  showNewAccount: boolean,
};

class SettingsNav extends React.Component {
  props: Props;

  renderTransactionsNavItem() {
    return (
      <NavItem key="Transactions" to="/settings/transactions">
        Transactions
      </NavItem>
    );
  }

  renderMessageSettingsNavItem() {
    return (
      <NavItem key="ChatSettings" to="/settings/chat">
        Message settings
      </NavItem>
    );
  }

  renderNotificationNavItem() {
    return (
      <NavItem
        key="NotificationSettings"
        to="/settings/notifications">
        Notifications
      </NavItem>
    );
  }

  renderPrivacyNavItem() {
    return (
      <NavItem key="PrivacySettings" to="/settings/privacy">
        Blocked users
      </NavItem>
    );
  }

  renderPrintNavItem() {
    return (
      <NavItem key="PrintSettings" to="/settings/export">
        Print
      </NavItem>
    );
  }

  renderUserProfileNavItem() {
    const to = this.props.showNewAccount ? '/settings/profile' : '/settings';
    return (
      <NavItem key="UserProfile" to={to}>
        Profile
      </NavItem>
    );
  }

  renderUserSettingsNavItem() {
    return (
      <NavItem key="UserSettings" to="/settings/account">
        Account Settings
      </NavItem>
    );
  }

  renderWidgetNavItem() {
    return (
      <NavItem key="WidgetSettings" to="/settings/widget">
        Widgets
      </NavItem>
    );
  }

  renderArchivedClassesNavItem() {
    return (
      <NavItem key="ArchivedClassesSettings" to="/settings/archived">
        Archived classes
      </NavItem>
    );
  }

  render() {
    return (
      <div className={cx('SettingsNav', this.props.className)}>
        <ul>
          {this.renderUserProfileNavItem()}
          {this.props.showNewAccount && this.renderUserSettingsNavItem()}
          {this.renderNotificationNavItem()}
          {this.props.showMessageSettings && this.renderMessageSettingsNavItem()}
          {this.props.canOwnGroups && this.renderWidgetNavItem()}
          {this.props.canOwnGroups && this.renderPrintNavItem()}
          {this.props.canGoToTransactionSettings && this.renderTransactionsNavItem()}
          {this.renderPrivacyNavItem()}
          {this.props.canOwnGroups && this.renderArchivedClassesNavItem()}
        </ul>
      </div>
    );
  }
}

export default SettingsNav;



// WEBPACK FOOTER //
// ./src/settings/components/SettingsNav.jsx